import React from 'react';
import './About.css';

const Education = () => {
        return (
                <div className="pb-5">
                        <h2 className="text-center text-white fw-bold text-decoration-underline">My <span className="brand-color">Education</span></h2>
                        <div className="education mt-5 ps-3"
                                data-aos="fade-right"
                                data-aos-offset="300"
                                data-aos-easing="ease-in-sine"
                        >
                                <div className="row mt-5">
                                        <div className="col-lg-5 col-md-5 col-12 d-flex align-items-center">
                                                <h4 className="brand-color fw-bolder">Under Graduation:</h4>
                                        </div>
                                        <div className="col-lg-7 col-md-7 col-12 text-white">
                                                <h6>B.Sc in Mathematics,</h6>
                                                <h6>Khulna University</h6>
                                                <h6>2019-Running</h6>
                                        </div>
                                </div>
                                <div className="row mt-5">
                                        <div className="col-lg-5 col-md-5 col-12 d-flex align-items-center">
                                                <h4 className="brand-color fw-bolder">Higher Secondary:</h4>
                                        </div>
                                        <div className="col-lg-7 col-md-7 col-12 text-white">
                                                <h6>HSC 2017</h6>
                                                <h6>Notre Dame College, Mymensingh.</h6>
                                                <h6>June, 2015 - June, 2017</h6>
                                        </div>
                                </div>
                                <div className="row mt-5">
                                        <div className="col-lg-5 col-md-5 col-12 d-flex align-items-center">
                                                <h4 className="brand-color fw-bolder">Secondary:</h4>
                                        </div>
                                        <div className="col-lg-7 col-md-7 col-12 text-white">
                                                <h6>SSC 2015</h6>
                                                <h6>Mukul Niketon High School, Mymensingh.</h6>
                                                <h6>January, 2009 - December, 2014</h6>
                                        </div>
                                </div>
                        </div>
                </div>
        );
};

export default Education;